KeyChars = require 'data/key-chars'
KeyLocations = require 'data/key-locations'

module.exports = Keys =
  Unknown: 'Unknown'

for value, name of KeyChars
  Keys[name] = name

for value, name of KeyLocations
  Keys[name] = name

# Convenience for the number keys so we can say Keys._0 instead of Keys['0']
for char in "0123456789".split('')
  Keys["_#{ char }"] = Keys[char]



// WEBPACK FOOTER //
// ./app/scripts/data/keys.coffee